import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { Page } from "../model/Page";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UpdatePossessionDtlListModel } from "../model/UpdatePossessionDtlListModel";
import { UpdatePossessionDtlModel } from "../model/UpdatePossessionDtlModel";
import { PossessionFamilyMemberDtl } from "../model/PossessionFamilyMemberDtl";

@Injectable({
  providedIn: "root",
})
export class PossessionDtlUpdateService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  fetchApplicationListForPossessionDtlUpdate(
    page: number,
    size: number,
    filterText: string
  ) {
    return this.httpClient.post<{
      data: Page<UpdatePossessionDtlListModel>;
      status: string;
      errorMessage: string;
    }>(
      ApiUrls.possesionDtlUpdateListFetchPageByFilterUrl +
        `?page=${page}&size=${size}`,
      { filterText }
    );
  }

  fetchApplicationDetailForPossessionDtlUpdate(applicationId: number) {
    return this.httpClient.get<UpdatePossessionDtlModel>(
      ApiUrls.possesionDtlUpdateApplicationDetailUrl.replace(
        "{applicationId}",
        applicationId.toString()
      )
    );
  }

  updatePossessionDetail(
    applicationId: number,
    data: {
      selfPhoto: string | ArrayBuffer;
      spousePhoto: string | ArrayBuffer;
      familyPhoto: string | ArrayBuffer;
      emailId: string;
      spouseEmailId: string;
      applicableSpouseName: string;
      possessionFamilyMemberDtl: PossessionFamilyMemberDtl[];
      afterUpdtPossessionFamilyMemberDtl: PossessionFamilyMemberDtl[];
    }
  ) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.possesionDtlUpdateUrl.replace(
        "{applicationId}",
        applicationId.toString()
      ),
      data
    );
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

   revertPossession(
    filterText?: string
  ) {
    let reqParams =
      (filterText ? `?filterText=${filterText}` : "");
    return this.httpClient.get<Page<UpdatePossessionDtlModel>>(
      ApiUrls.revertpossisionLetter + reqParams
        
    );
  }

  revertAllotment(
    filterText?: string
  ) {
    let reqParams =
      (filterText ? `?filterText=${filterText}` : "");
    return this.httpClient.get<Page<UpdatePossessionDtlModel>>(
      ApiUrls.revertallotmentLetter + reqParams
        
    );
  }
}
